import { DetailedHTMLProps, InputHTMLAttributes } from "react";
import { Button as BulmaButton, Media } from "react-bulma-components";
import { Button } from "@adfenix/alexandria";
import styled from "styled-components";

export const CheckContainer = styled.div`
  width: 48px;
  height: 48px;
  margin: 20px auto;
`;

export const MediaComponent = styled(Media)`
  @media (min-width: 768px) {
    display: block;
    marging-top: 20px;
  }
`;

export const StyledBulmaButton = styled(BulmaButton)`
  width: 100%;
  margin-top: 32px;
  z-index: 9999;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 32px;
  z-index: 9999;
`;

export const Fieldset = styled.fieldset`
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  padding: 8px 0;
  border: 1px solid #50657c;

  & label {
    position: relative;
    display: flex;
    flex-direction: row;
    height: 42px;
    padding: 10px 0;
    align-items: center;
    justify-content: center;
    font-weight: 400;
  }

  & label:not(:last-child) {
    border-bottom: 1px solid #f0f5fa;
  }

  & label.state {
    display: inline-flex;
    width: 65%;
  }

  & ::not(.with-state) label.state {
    display: none;
  }

  & label.zip {
    display: inline-flex;
    width: 35%;
    padding-right: 60px;
  }

  & ::not(.with-state) label.zip {
    width: 100%;
  }

  & label span {
    min-width: 125px;
    padding: 0 15px;
    text-align: right;
  }

  & .redirect label span {
    width: 100%;
    text-align: center;
  }

  & select {
    flex: 1;
    border-style: none;
    outline: none;
    font-size: inherit;
    appearance: none;
    outline: none;
    color: #313b3f;
    background: transparent;
  }

  @media only screen and (max-width: 500px) {
    margin-bottom: 15px;

    & label span {
      min-width: 90px;
      padding: 0 15px;
      text-align: left;
    }

    & label.state,
    & label.zip {
      display: flex;
      width: inherit;
      padding: 10px 0;
    }
  }
`;

const countryStyles = `
      display: flex;
      align-items: center;

      & select {
        margin: 0 -15px 0 -30px;
        padding: 0 15px 0 30px;
      }
   `;

interface InputProps
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  country?: boolean;
}

export const Input = styled.input<InputProps>`
  font-size: inherit;
  flex: 1;
  padding: 0 15px;
  background: transparent;
  width: fill-available;
  margin-right: 15px;
  font-weight: 400;
  color: #31325f;
  outline: none;
  border: none;
  cursor: text;

  ::placeholder {
    color: #aab7c4;
  }

  ${props => props.country && countryStyles}
`;

export const ErrorSection = styled.section`
  text-align: center;
  & h4 {
    color: #f65b41;
  }
`;

export const StyledDeleteButton = styled.button`
  padding-right: 12px;
  border: none;
  display: inline-flex;
  font-size: inherit;
  color: #f65b41;
  font-weight: 500;
  cursor: pointer;

  :focus {
    outline: none;
  }
`;

export const CancelButton = styled.p`
  margin-top: 20px;
  text-decoration: underline;
  cursor: pointer;
`;

export const RemoveCardSection = styled.section`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 20px 40px 20px;
`;

export const CreditCardContainer = styled.div`
  display: flex;
  background: #fff;
  border: 1px solid #d0d8e2;
  border-radius: 4px;
  padding: 8px;
  color: #0f2a3e;
`;

export const CreditCardInput = styled.div`
  display: flex;
  align-items: center;

  & span {
    padding: 0 10px;
  }
`;
